import { render, staticRenderFns } from "./CopyStakeWhitelistFilter.vue?vue&type=template&id=211e59fa&scoped=true&lang=pug"
import script from "./CopyStakeWhitelistFilter.vue?vue&type=script&lang=ts"
export * from "./CopyStakeWhitelistFilter.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeWhitelistFilter.vue?vue&type=style&index=0&id=211e59fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211e59fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSelect,VTextField})
